<template>
  <div id="rangeSlider" ref="rangeSlider" class="range-slider">
    <input
      ref="rangeInput"
      type="range"
      :min="min"
      :max="max"
      :value="value"
      @input="changeRange"
    />
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue'

withDefaults(
  defineProps<{
    min: number
    max: number
    value: number
  }>(),
  {
    min: 0,
    max: 100,
    value: 0,
  }
)
const emit = defineEmits<{
  (e: 'change-range', range: number): void
}>()

const range = ref(1)

function changeRange(event: Event) {
  range.value = +(event.target as HTMLInputElement)?.value
  emit('change-range', range.value)
}
</script>

<style lang="scss">
#rangeSlider.range-slider {
  max-height: 16px;
  input[type='range']:not([type='checkbox']) {
    padding-left: 0 !important;
    -webkit-appearance: auto !important;
    appearance: auto !important;
    cursor: pointer;
    border: none !important;
    max-height: 16px !important;
    min-height: 16px !important;
  }
}
</style>
